/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Penalty totals in financials response
 * @export
 * @interface FinancialsPenalties
 */
export interface FinancialsPenalties {
    /**
     * 
     * @type {number}
     * @memberof FinancialsPenalties
     */
    count?: number;
    /**
     * 
     * @type {number}
     * @memberof FinancialsPenalties
     */
    total?: number;
}

/**
 * Check if a given object implements the FinancialsPenalties interface.
 */
export function instanceOfFinancialsPenalties(value: object): value is FinancialsPenalties {
    return true;
}

export function FinancialsPenaltiesFromJSON(json: any): FinancialsPenalties {
    return FinancialsPenaltiesFromJSONTyped(json, false);
}

export function FinancialsPenaltiesFromJSONTyped(json: any, ignoreDiscriminator: boolean): FinancialsPenalties {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'] == null ? undefined : json['count'],
        'total': json['total'] == null ? undefined : json['total'],
    };
}

export function FinancialsPenaltiesToJSON(json: any): FinancialsPenalties {
    return FinancialsPenaltiesToJSONTyped(json, false);
}

export function FinancialsPenaltiesToJSONTyped(value?: FinancialsPenalties | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
        'total': value['total'],
    };
}

